import { Bell, BellOff } from "lucide-react";

import type { EventAlarmType } from "../api/types";

interface SymbolEventAlarmsSectionProps {
  symbol: string | null;
  eventTypes: EventAlarmType[];
  alarmEmailEnabled: boolean;
  subscribedEventTypes: Set<string>;
  pendingEventType: string | null;
  onToggleAlarm: (eventType: string, eventTitle: string, isSubscribed: boolean) => void;
}

export function SymbolEventAlarmsSection({
  symbol,
  eventTypes,
  alarmEmailEnabled,
  subscribedEventTypes,
  pendingEventType,
  onToggleAlarm,
}: SymbolEventAlarmsSectionProps) {
  return (
    <div className="agent-signals-section">
      <div className="companion-heading">
        <p className="panel-eyebrow">Symbol Events</p>
      </div>
      <div className="companion-status">
        {symbol ? `Fundamental events for ${symbol}` : "Select a symbol to manage its event alarms."}
      </div>
      {!alarmEmailEnabled && (
        <p className="agent-signals-note">
          Email alarms are not configured on this server yet - the bell toggles below will not
          send mail until SMTP is set up.
        </p>
      )}
      <p className="agent-signals-note">
        Leadership Change is beta: it diffs Yahoo Finance's officer list, which has no clean
        change event, so a harmless data refresh can occasionally trigger it too.
      </p>
      <div className="agent-signals-list">
        {eventTypes.map((eventType) => {
          const isSubscribed = subscribedEventTypes.has(eventType.key);
          const isPending = pendingEventType === eventType.key;
          return (
            <div className="agent-signal-row" key={eventType.key}>
              <div className="agent-signal-main">
                <span className="agent-signal-title">{eventType.title}</span>
              </div>
              <button
                type="button"
                className={`bell-toggle${isSubscribed ? " is-active" : ""}`}
                disabled={isPending || !symbol}
                aria-pressed={isSubscribed}
                title={
                  isSubscribed
                    ? `Stop emailing me about ${eventType.title} on ${symbol}`
                    : `Email me when ${eventType.title} changes for ${symbol}`
                }
                onClick={() => onToggleAlarm(eventType.key, eventType.title, isSubscribed)}
              >
                {isSubscribed ? <Bell size={16} /> : <BellOff size={16} />}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
